import styled, { keyframes, css } from 'styled-components';
import { mixins, colors, media, zIndex } from '../../css';

const slideIn = css`
  ${keyframes`
  0% {
    transform: translateY(-500px);
    opacity: 0;
  }  
  100% {
      transform: translateY(0);
      opacity: 1;
    }
    
  `}
`;

const slideOut = css`
  ${keyframes`
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-500px);
    opacity: 0;
  }
`}
`;

export const NavBorder = styled.div`
  width: 100%;
  background-color: ${colors.colorWhite};
`;

export const NavWrapper = styled.div`
  position: fixed;
  display: block;
  width: 100%;
  height: 55px;
  z-index: ${zIndex?.navigation?.main || 'inherit'};

  ${media.greaterThan('lg')`height: ${mixins.pxToRem(80)};`};

  ${media.lessThan('lg')`
  position: relative;

   &.nav-visible {
    ${NavBorder} {
      position: fixed;
      top: 0;
      left: 0;
      animation: ${slideIn} 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    }
  }

  &.nav-hidden {
    ${NavBorder} {
      position: fixed;
      top: 0;
      left: 0;
      animation: ${slideOut} 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
    }
  }
  `};
`;
